import z from 'zod';

const eventFeedBasePath = 'event-feed/v1/';

export const eventFeedRequestSchema = z.object({
  watchlists: z.array(z.string()).optional(),
  competitors: z.boolean().optional(),
  entities: z.array(z.string()).optional(),
  type: z.string().optional(),
  limit: z.number().int().optional(),
  next: z.string().optional(),
  prev: z.string().optional(),
});

const relevanceConnectionSchema = z.object({
  entity: z.string(),
  watchlist_ids: z.array(z.string()),
});

const relevanceTierSchema = z.union([z.literal(1), z.literal(2), z.literal(3)]);

const relevanceSchema = z.object({
  tier: relevanceTierSchema,
  connections: z.array(relevanceConnectionSchema).nullish(),
});

const eventSchema = z.object({
  id: z.string(),
  type: z.string(),
  entity: z.string(),
  created_at: z.string(),
  title: z.string(),
  summary: z.string(),
  metadata: z.record(z.string(), z.unknown()),
  read: z.boolean(),
  relevance: relevanceSchema,
});

export const eventFeedResponseSchema = z.object({
  events: z.array(eventSchema),
  next_cursor: z.string().nullish(),
  prev_cursor: z.string().nullish(),
});

export type EventFeedRequest = z.infer<typeof eventFeedRequestSchema>;
export type EventFeedResponse = z.infer<typeof eventFeedResponseSchema>;
export type EventFeedEvent = z.infer<typeof eventSchema>;
export type EventFeedRelevance = z.infer<typeof relevanceSchema>;
export type EventFeedRelevanceTier = z.infer<typeof relevanceTierSchema>;
export type EventFeedRelevanceConnection = z.infer<
  typeof relevanceConnectionSchema
>;

export const eventFeed = {
  postFeedEvents: {
    path: `${eventFeedBasePath}events`,
    schema: eventFeedResponseSchema,
  },
  postEventRead: {
    path: (eventId: string) => `${eventFeedBasePath}events/${eventId}/read`,
  },
};
